// Display setting for string IDs
export enum StringIDdisplay { none=0, displayIdAfter=1, displayIdBefore=2 }
